import React from 'react';
import {
  Control,
  UseFormGetValues,
  UseFormRegister,
  UseFormWatch,
} from 'react-hook-form';
import { ApplicationFormTemplate } from '../../../../../../entities/applicant_tracking/ApplicationFormTemplate';
import { PreviewJobPost } from '../../../../../../entities/applicant_tracking/PreviewJobPost';
import { Source } from '../../../../../../entities/applicant_tracking/Source';
import { ApplicationSalaryInput } from '../../../../Applications/ApplicationSalaryInput';
import { HasWorkingVisaInput } from '../../../../Applications/HasWorkingVisaInput';
import { SourceInput } from '../../../../Applications/SourceInput';

interface PropTypes {
  previewJobPost: PreviewJobPost;
  applicationFormTemplate: ApplicationFormTemplate;
  sources: Source[];
  previewMode: boolean;
  formRegister: UseFormRegister<any>;
  formResetField: (controllerName: string) => void;
  formControl: Control<any, any>;
  formWatch: UseFormWatch<any>;
  formGetValues: UseFormGetValues<any>;
}

function shouldRender(aft: ApplicationFormTemplate): boolean {
  return (
    aft.expectedSalaryEnabled || aft.hasWorkingVisaEnabled || aft.sourceEnabled
  );
}

export function ApplicationFormJobApplicationSection(props: PropTypes) {
  if (!shouldRender(props.applicationFormTemplate)) return null;

  return (
    <>
      <h3 className='py-3 my-0'>Job Application</h3>
      <SourceInput
        label={'Where did you hear about this job opening?'}
        sources={props.sources}
        formControl={props.formControl}
        shouldRender={props.applicationFormTemplate.sourceEnabled}
        disabled={props.previewMode}
      />
      <HasWorkingVisaInput
        label={`Do you have the legal right to work in ${props.previewJobPost.locationCountry}?`}
        formRegister={props.formRegister}
        formControl={props.formControl}
        shouldRender={props.applicationFormTemplate.hasWorkingVisaEnabled}
        disabled={props.previewMode}
      />
      <ApplicationSalaryInput
        containerClassNames={'mb-4 fs-5 fw-semibold'}
        formHeaderClassNames={'px-0 mb-1'}
        inputGroupClassNames={'px-0'}
        salaryInputColSize={6}
        formControl={props.formControl}
        watch={props.formWatch}
        formRegister={props.formRegister}
        formResetField={props.formResetField}
        disabled={props.previewMode}
        shouldRender={props.applicationFormTemplate.expectedSalaryEnabled}
      />
    </>
  );
}
